
export function captureCurrentFrame(player, scaleFactor) {
    if (scaleFactor == null) {
        scaleFactor = 1;
    }

    const w = player.videoWidth() * scaleFactor;
    const h = player.videoHeight() * scaleFactor;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(player.children_[0], 0, 0, w, h);
    return canvas;
  }
  
export function checkUserAuthorization(server, document) {

    if (!document.restricted)
        return true;

    const { userRole, currentUserGroups } = server;
    if (userRole !== 'superAdmin' && userRole !== 'admin') {
        //  if (document.author !== user.username) {
        if (userRole !== 'groupAdmin') {
            return false;
        } else {
            const allowedGroups = currentUserGroups.usergroupsAdmin.map(g => g._id)
            const isGroupAdmin = document.usergroups.some(group => allowedGroups.includes(group));
            return isGroupAdmin;
        }
        //  }
    } 
    else 
        return true;
}

export function checkUserAuthorizationForRestricted(server, document) {

    const { userRole, currentUserGroups } = server;
    if (userRole !== 'superAdmin' && userRole !== 'admin') {
        //  if (document.author !== user.username) {
        if (userRole !== 'groupAdmin') {
            return false;
        } else {
            const allowedGroups = currentUserGroups.usergroupsAdmin.map(g => g._id)
            const isGroupAdmin = document.usergroups.some(group => allowedGroups.includes(group));
            return isGroupAdmin;
        }
        //  }
    } 
    else 
        return true;
}


export function convertLatitudeToDMS(latitude) {
    const direction = latitude >= 0 ? 'N' : 'S'; // Determine if it's North or South
    const absoluteLatitude = Math.abs(latitude); // Get the absolute value of the latitude

    const degrees = Math.floor(absoluteLatitude); // Extract the degrees
    const minutesDecimal = (absoluteLatitude - degrees) * 60; // Calculate the minutes as a decimal
    const minutes = Math.floor(minutesDecimal); // Extract the whole minutes
    const seconds = ((minutesDecimal - minutes) * 60).toFixed(2); // Calculate the seconds and round to 2 decimal places

    return `${degrees}° ${minutes}' ${seconds}" ${direction}`;
}

export function convertLongitudeToDMS(longitude) {
    const direction = longitude >= 0 ? 'E' : 'W'; // Determine if it's East or West
    const absoluteLongitude = Math.abs(longitude); // Get the absolute value of the longitude

    const degrees = Math.floor(absoluteLongitude); // Extract the degrees
    const minutesDecimal = (absoluteLongitude - degrees) * 60; // Calculate the minutes as a decimal
    const minutes = Math.floor(minutesDecimal); // Extract the whole minutes
    const seconds = ((minutesDecimal - minutes) * 60).toFixed(2); // Calculate the seconds and round to 2 decimal places

    return `${degrees}° ${minutes}' ${seconds}" ${direction}`;
}

export function convertMongoIdToTimestamp(mongoId) {
    if (!mongoId || typeof mongoId !== 'string' || mongoId.length !== 24) {
        return 'Invalid ID';
    }

    try {
        // Extract the first 4 bytes (8 characters) of the ObjectID
        const timestampHex = mongoId.substring(0, 8);
        // Convert the hexadecimal timestamp to an integer
        const timestamp = parseInt(timestampHex, 16);
        // Convert the timestamp to a JavaScript Date object
        const date = new Date(timestamp * 1000); // Multiply by 1000 to convert seconds to milliseconds
        // Format the date to a readable local time string
        return date.toLocaleString();
    } catch (error) {
        console.error('Error converting MongoDB ID to timestamp:', error);
        return 'Invalid ID';
    }
}


export function toGeoJson(annotation) {
    if (!annotation) {
      return null;
    }
  
    return {
      type: 'FeatureCollection',
      features: (annotation.features || []).map(feature => ({
        ...feature,
        properties: {
          ...feature.properties,
          _id: annotation._id,
          title: annotation.title,
          description: annotation.description,
          category: annotation.category
        }
      }))
    };
  }


  /**
 * Compute the center point of a GeoJSON object by its bounding box.
 * @param {Object} geoJson - Any valid GeoJSON object
 * @returns {[number, number] | null} [lng, lat] or null if no coordinates found
 */
export function getGeoJsonCenter(geoJson) {
    const coords = [];
  
    // Recursively extract all coordinate pairs into `coords`
    function extract(geom) {
      if (!geom) return;
  
      switch (geom.type) {
        case 'Feature':
          extract(geom.geometry);
          break;
        case 'FeatureCollection':
          geom.features.forEach(f => extract(f));
          break;
        case 'GeometryCollection':
          geom.geometries.forEach(g => extract(g));
          break;
        case 'Point':
          coords.push(geom.coordinates);
          break;
        case 'MultiPoint':
        case 'LineString':
          geom.coordinates.forEach(c => coords.push(c));
          break;
        case 'MultiLineString':
        case 'Polygon':
          geom.coordinates.flat().forEach(c => coords.push(c));
          break;
        case 'MultiPolygon':
          geom.coordinates.flat(2).forEach(c => coords.push(c));
          break;
        default:
          // unknown geometry type
          break;
      }
    }
  
    extract(geoJson);
  
    if (coords.length === 0) return null;
  
    // Separate lons and lats
    const lons = coords.map(c => c[0]);
    const lats = coords.map(c => c[1]);
  
    const minLon = Math.min(...lons);
    const maxLon = Math.max(...lons);
    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
  
    // Center of bounding box
    return [
      (minLon + maxLon) / 2,
      (minLat + maxLat) / 2
    ];
  }
